import {AfterViewInit, Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[labelTextWrapping]',
    standalone: false
})
export class LabelTextWrappingDirective implements AfterViewInit {
  constructor(
    public hostElement: ElementRef,
  ) {
  }
  private labelEl: HTMLElement | null = null;
  private inputElement: HTMLElement | null = null;
  private height = 0;

  @HostListener('click', ['$event']) onClick(_event: Event) {
    if (this.labelEl && this.inputElement) {
      this.height = this.labelEl.offsetHeight - (this.labelEl.offsetHeight * .28);
      this.inputElement.setAttribute('style', `padding-top: ${this.height}px;`);
    }

    setTimeout(() => {
      if (this.labelEl && this.inputElement) {
        this.height = this.labelEl.offsetHeight - (this.labelEl.offsetHeight * .28);
        this.inputElement.setAttribute('style', `padding-top: ${this.height}px;`);
      }
    }, 200);
  }

  ngAfterViewInit() {
    const el = this.hostElement.nativeElement as HTMLElement;
    // MDC (Angular Material 15+): .mat-mdc-floating-label, .mdc-floating-label
    // Legacy: .mat-form-field-label
    this.labelEl = el.querySelector<HTMLElement>('.mat-mdc-floating-label, .mdc-floating-label, .mat-form-field-label');
    // MDC: .mat-mdc-form-field-infix | Legacy: .mat-form-field-infix
    this.inputElement = el.querySelector<HTMLElement>('.mat-mdc-form-field-infix, .mat-form-field-infix');

    if (this.labelEl && this.inputElement) {
      this.labelEl.setAttribute('style', 'white-space: break-spaces;');
      this.height = this.labelEl.offsetHeight - (this.labelEl.offsetHeight * .28);
      this.inputElement.setAttribute('style', `padding-top: ${this.height}px;`);
    }
  }

}
